import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Icon from '@/Components/Icon/Icon';
const ListItemTags = ({ hideTags, tags }) => {
    if (hideTags || !tags.length) {
        return null;
    }
    return (_jsx("div", { className: "mt-1.5 flex flex-wrap gap-2 overflow-hidden text-sm lg:text-xs", children: tags.map((tag) => (_jsxs("span", { className: "inline-flex items-center rounded bg-passive-4-opacity-variant px-1.5 py-1 text-foreground", children: [_jsx(Icon, { type: tag.iconString, className: "mr-1 text-passive-1", size: "small" }), _jsx("span", { children: tag.title })] }, tag.uuid))) }));
};
export default ListItemTags;
